import React, { useEffect } from 'react'
import { Navigate, useSearchParams } from 'react-router-dom'
import FollowButton from '../Components/FollowButton'
import CollapsingHeader from '../Components/CollapsingHeader'
import SortedFeed, { useSortParam } from '../Components/SortedFeed'
import { useDocumentTitle } from '../Hooks/useDocumentTitle'
import { useFeed } from '../Hooks/useFeed'
import { saveRecentSearch } from '../Hooks/useSearch'
import { t } from '../i18n'
import { api } from '../Services/api'
import { useFollow } from '../State/Follow'

/* "Sve vijesti za X": stories matching the words, with "+ Prati" to keep the
   words as one of Moje teme. */
export default function SearchResults() {
  const [params] = useSearchParams()
  const query = (params.get('q') || '').replace(/\s+/g, ' ').trim()
  const [sort, setSort] = useSortParam()
  const { sources: followed } = useFollow()
  const feed = useFeed(
    `search:${query.toLowerCase()}:${sort}:${followed.join(',')}`,
    ({ cursor, refresh }) => api.searchStories(query, { sort, cursor, followed, refresh }),
    { enabled: query.length >= 2 }
  )
  useDocumentTitle(query || null)
  useEffect(() => {
    if (query.length >= 2) saveRecentSearch(query)
  }, [query])

  if (query.length < 2) return <Navigate to="/istrazi" replace />
  const label = feed.extra.query || query
  return (
    <>
      <CollapsingHeader
        title={label}
        action={
          <FollowButton kind="keyword" item={{ title: label }} variant="header" from="search" />
        }
        compactAction={
          <FollowButton
            kind="keyword"
            item={{ title: label }}
            variant="header"
            from="search"
            small
          />
        }
      />
      <SortedFeed
        feed={feed}
        sort={sort}
        setSort={setSort}
        from="search"
        empty={<p>{t('myTopics.noNews')}</p>}
      />
    </>
  )
}
